// Bridge to the relocasa-app's WebView shell. The shell injects
// window.ReactNativeWebView into the page; its RelocasaWebView.onMessage
// parses JSON messages posted here (e.g. OPEN_SUPER_INTEREST_PURCHASE
// opens the app's own payment panel). Outside the app nothing is posted
// and postToApp says so, so the caller can fall back to the web's own UI.

export function isInAppWebView() {
  return typeof window !== 'undefined' && !!window.ReactNativeWebView;
}

export function postToApp(message) {
  if (!isInAppWebView()) {
    return false;
  }
  window.ReactNativeWebView.postMessage(JSON.stringify(message));
  return true;
}
